import { HistoryRecord, VersionHistory } from './types';

export class SessionStorageCache<T> implements VersionHistory<T> {
  private lastVersionIndex: number = 0;
  private readonly cacheLimit: number;
  private readonly storageKey: string = 'SgVersionCache';

  constructor(cacheLimit: number) {
    this.cacheLimit = cacheLimit;
    this.loadCache();
  }

  private loadCache(): void {
    const cachedData = sessionStorage.getItem(this.storageKey);
    if (cachedData) {
      const parsedData: HistoryRecord<T>[] = JSON.parse(cachedData);
      this.lastVersionIndex = parsedData.length
        ? parsedData[parsedData.length - 1].index
        : 0;
    }
  }

  getVersion(index: number): T | null {
    const cachedData = sessionStorage.getItem(this.storageKey);
    if (!cachedData) return null;

    const parsedData: HistoryRecord<T>[] = JSON.parse(cachedData);
    const versionRecord = parsedData.find(
      ({ index: verIndex }) => verIndex === index,
    );
    return versionRecord ? versionRecord.data : null;
  }

  pushVersion(data: T): number {
    this.lastVersionIndex += 1;

    const cachedData = sessionStorage.getItem(this.storageKey);
    const cache: HistoryRecord<T>[] = cachedData ? JSON.parse(cachedData) : [];

    cache.push({ data, index: this.lastVersionIndex });

    if (cache.length > this.cacheLimit) {
      cache.shift();
    }

    sessionStorage.setItem(this.storageKey, JSON.stringify(cache));
    return this.lastVersionIndex;
  }

  getLastVersionIndex(): number {
    return this.lastVersionIndex;
  }

  getAvailableVersionIndexes(): number[] {
    const cachedData = sessionStorage.getItem(this.storageKey);
    if (!cachedData) return [];

    const cache: HistoryRecord<T>[] = JSON.parse(cachedData);
    return cache.map(({ index }) => index);
  }
}
